import { grey } from "@material-ui/core/colors";
import OHLogo from "../assets/img/oh-logo.png"
export const GA_IDENTIFIER = "mi_website"

export const PRIMARY = '#dd0000'
export const SECONDARY = "#ffffff"
export const OH_LOGO = OHLogo